import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-image-effect-form",
  templateUrl: "./product-image-effect-form.component.html",
  styleUrls: ["./product-image-effect-form.component.scss"],
})
export class ProductImageEffectFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-image-effect-form/product-image-effect-form.component.ts